export interface IClickHandleable {
  clicked(): void;
}

export function instanceOfIClickHandleable(instance: any): instance is IClickHandleable {
  return instance
    && (instance.clicked !== undefined);
}
